import { FormattedMessage } from 'react-intl';
import Flag from 'react-world-flags';

// Define a type for your language keys
type LanguageKeys = 'German' | 'English' | 'Spanish' | 'Chinese' | 'Hindi' | 'French' | 'Arabic' | 'Bengali' | 'Russian' | 'Portuguese' | 'Urdu' | 'Indonesian' | 'Japanese' | 'Swahili' | 'Turkish';

export const TOP_LANGUAGES: LanguageKeys[] = [
  'German',
  'English',
  'Spanish',
  'Chinese',
  'Hindi',
  'French',
  'Arabic',
  'Bengali',
  'Russian',
  'Portuguese',
  'Urdu',
  'Indonesian',
  'Japanese',
  'Swahili',
  'Turkish'
];

export const getFlagCode = (language: string) => {
  const flagCodes: { [key: string]: string } = {
    German: 'DE',
    English: 'GB',
    Spanish: 'ES',
    Chinese: 'CN',
    Hindi: 'IN',
    French: 'FR',
    Arabic: 'AE',
    Bengali: 'BD',
    Russian: 'RU',
    Portuguese: 'PT',
    Urdu: 'PK',
    Indonesian: 'ID',
    Japanese: 'JP',
    Swahili: 'KE',
    Turkish: 'TR'
  };

  return flagCodes[language as keyof typeof flagCodes];
};

export const languageOptions = (intl: any, getFlagCode: any) => {
  return TOP_LANGUAGES.map((lang) => ({
    value: lang,
    label: <FormattedMessage id={`home.language.${lang}`} />,
    icon: <Flag code={getFlagCode(lang)} style={{ width: '20px', height: '15px' }} />
  }));
};
